<template>
  <div class="classic-website">
    <!-- 第一区域：顶部公司信息 -->
    <!-- 网站顶部的component共用模块引入 -->
    <atop ref="atop"></atop>
    
    <!-- 第二区域：全站搜索区 -->
    <!-- 网站搜索区的component共用模块引入 -->
    <atopsearch ref="atopsearch"></atopsearch>

    <!-- 第三区域：书籍分类与推荐 -->
    <section class="main-section">
      <div class="container main-container">
        <!-- 移动端书籍分类折叠按钮 -->
        <!-- <el-button -->
        <div
          ref="mobileCategoriesBtn"
          class="mobile-categories-toggle" 
          @click="toggleMobileCategories"
          v-if="isMobile"
        >
          <div ref="buttonindiv" style="width:100% !important;display:flex;flex-direction: row;justify-content: space-between;align-items: center;">
            <div class="toggle-icon" :class="{ expanded: showMobileCategories }">
              <i class="fas fa-chevron-right" v-if="showMobileCategories"></i>
              <i class="fas fa-bars" v-else></i>
            </div>
            <div>书籍分类</div>
            <div v-if="!showMobileCategories"><i class="fas fa-chevron-right"></i></div>
            <div v-else></div>
          </div>
        <!-- </el-button> -->
        </div>

        <!-- 左侧：书籍分类 -->
        <div 
          class="categories-box" 
          :class="{ show: showMobileCategories }"
          id="categoriesBox"
        >
          <h2 class="categories-title">书籍分类</h2>
          <div class="categories-list">
            <!-- 20260323 modify，首页界面上一级分类有无二级分类都展示一级分类，不点击一级分类展示二级分类 -->
            <!-- <div 
              v-for="category in categories"
              :key="category.typename"
              class="category-item"
              :class="{ 'journal-item': category.typename === '期刊报纸（有年份差别）' }"
              @click="handleCategoryClick(category)"
            >
              {{ category.typename }}
            </div> -->
            <div 
              v-for="category in categories"
              :key="category.typename"
              class="category-item"
              @click="handleCategoryClick(category)"
            >
              {{ category.typename }}
            </div>
          </div>
        </div>

        <!-- 右侧：推荐区域 -->
        <div class="recommendations-box">
          <!-- 特别推荐 -->
          <div class="recommendation-section">
            <div class="section-header">
              <h2 class="section-title">特别推荐</h2>
              <!-- <a href="#" class="more-link">更多 <i class="el-icon-arrow-right"></i></a> 20260106-->
              <!-- <a href="#" class="more-link" @click="handleMoreClick(1)">更多 <i class="fas fa-chevron-right"></i></a> -->
              <span class="more-link" style="cursor: pointer;" @click="handleMoreClick(1)">更多 <i class="fas fa-chevron-right"></i></span>
            </div>
            <div class="books-grid">
              <div 
                v-for="book in featuredBooks" 
                :key="book.id"
                class="book-item"
                @click="handleBookClick(book)"
              >
                <div class="book-cover">
                  <img 
                    :src="book.cover" 
                    :alt="book.title"
                    @error="handleBookImageError(book)"
                    @load="handleBookImageLoad(book)"
                  >
                  <div v-if="book.imageError" class="image-placeholder">
                    <i class="el-icon-picture"></i>
                    <span>{{ book.title }}</span>
                  </div>
                </div>
                <div class="book-title">{{ book.title }}</div>
              </div>
            </div>
          </div>

          <!-- 即将出版 -->
          <div class="recommendation-section">
            <div class="section-header">
              <h2 class="section-title">即将出版</h2>
              <!-- <a href="#" class="more-link">更多 <i class="el-icon-arrow-right"></i></a> 20260105-->
              <!-- <a href="#" class="more-link" @click="handleMoreClick(2)">更多 <i class="fas fa-chevron-right"></i></a> -->
              <span class="more-link" style="cursor: pointer;" @click="handleMoreClick(2)">更多 <i class="fas fa-chevron-right"></i></span>
            </div>
            <div class="books-grid">
              <div 
                v-for="book in upcomingBooks" 
                :key="book.id"
                class="book-item"
                @click="handleBookClick(book)"
              >
                <div class="book-cover">
                  <img 
                    :src="book.cover" 
                    :alt="book.title"
                    @error="handleBookImageError(book)"
                    @load="handleBookImageLoad(book)"
                  >
                  <div v-if="book.imageError" class="image-placeholder">
                    <i class="el-icon-picture"></i>
                    <span>{{ book.title }}</span>
                  </div>
                </div>
                <div class="book-title">{{ book.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四区域：页脚 -->
    <!-- 网站页脚的component共用模块引入 -->
    <abottom ref="abottom"></abottom>

    <!-- 更多分类弹出层 -->
    <el-dialog
      :visible.sync="showTagsModal"
      title="更多书籍分类"
      width="700px"
      :show-close="false"
      custom-class="custom-modal"
    >
      <div class="modal-tags">
        <div 
          v-for="tag in additionalTags"
          :key="tag"
          class="modal-tag"
          @click="handleModalTagClick(tag)"
        >
          {{ tag }}
        </div>
      </div>
      <div class="modal-description" v-if="showDescription">
        <p><strong>温馨提示：</strong>点击上方任意分类标签，该标签内容将自动填充到搜索框中，您可以直接进行搜索，或进一步细化搜索关键词。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTagsModal = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getBookOneType, getBookRecommand, getBookWillPub} from '../../api/home'
import { developmentUrl } from "../../config/env";

export default {
  name: 'ClassicBookWebsite',
  data() {
    return {
      searchKeyword: '',
      showMobileCategories: false,
      showTagsModal: false,
      showDescription: true,
      isMobile: false,
      years: Array.from({ length: 15 }, (_, i) => 2011 + i),
      
      //动态化数据完成
      categories: [],
      featuredBooks: [],
      upcomingBooks: [],

      additionalTags: [
        '东南亚文献', '南亚文献', '东北亚文献', '中国周边关系文献', 
        '一带一路', '区域国别文献', '各国馆藏文献', '域外古籍',
        '传世医学', '考古古物', '中国农学遗产文献', '商业经济文献', 
        '专题史料文献'
      ],
      defaultBookCover: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="280" viewBox="0 0 200 280"><rect width="200" height="280" fill="#8b4513"/><rect x="10" y="10" width="180" height="260" fill="#f5deb3"/><text x="100" y="140" font-family="Arial" font-size="14" text-anchor="middle" fill="#5c3a21">书籍封面</text></svg>'
    }
  },
  mounted() {
    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth)
    
    // 点击页面其他地方隐藏子菜单
    // 20260126 remark 期刊子菜单点击
    // document.addEventListener('click', this.handleDocumentClick)
    
    // 预加载图片
    this.preloadImages()

    //20260108 add,获取移动手机上分类按钮的宽度，并设置其中的div的宽度
    this.$nextTick(() => {
      if(this.isMobile){
        let buttonwidth = this.getButtonWidth();
        this.$refs.buttonindiv.style.width = buttonwidth - 24 + 'px';
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)

    // 20260126 remark 期刊子菜单点击
    // document.removeEventListener('click', this.handleDocumentClick)
  },

  //初始化获取网络数据
  created() {
      this.GetBookOneType();
      this.GetBookRecommand();
      this.GetBookWillPub();
  },

  methods: {
    //获取书籍一级分类服务数据
    GetBookOneType(){
      let queryParams = {};
      getBookOneType(queryParams).then(response => {
          this.categories = response.data.data;
      })
    },
    //获取特别推荐的书籍服务数据
    GetBookRecommand(){
      let queryParams = {};
      queryParams.pageNum = 1;
      queryParams.pageSize = 8;
      queryParams.isrecommand = '1';  //特别推荐
      queryParams.ispublish = '1';  //发布书籍
      getBookRecommand(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        // let recordnums = response.data.total;
        for(let i=0;i<listdata.length;i++){
          let onemap = {};
          onemap.id = listdata[i].id;
          onemap.title = listdata[i].seriesname;
          onemap.booknums = listdata[i].booknums;
          //onemap.cover = require('../../assets/bookpic/book08.jpg');
          let pictureStr = listdata[i].bookpicture.replace(/^\["/, '').replace(/"\]$/, '');     //去掉数据库中存储的两边的 ["  和 "]
          onemap.cover = developmentUrl + pictureStr.substring(1);
          onemap.imageError = false;
          onemap.imageLoaded = false;
          this.featuredBooks.push(onemap);
        }
      })
    },
    //获取即将出版的书籍服务数据
    GetBookWillPub(){
      let queryParams = {};
      queryParams.pageNum = 1;
      queryParams.pageSize = 8;
      queryParams.ispublish = '1';  //发布书籍
      getBookWillPub(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        // let recordnums = response.data.total;
        for(let i=0;i<listdata.length;i++){
          let onemap = {};
          onemap.id = listdata[i].id;
          onemap.title = listdata[i].seriesname;
          onemap.booknums = listdata[i].booknums;
          //onemap.cover = require('../../assets/bookpic/book08.jpg');
          let pictureStr = listdata[i].bookpicture.replace(/^\["/, '').replace(/"\]$/, '');     //去掉数据库中存储的两边的 ["  和 "]
          onemap.cover = developmentUrl + pictureStr.substring(1);
          onemap.imageError = false;
          onemap.imageLoaded = false;
          this.upcomingBooks.push(onemap);
        }
      })
    },
    

    checkScreenWidth() {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.showMobileCategories = false
      }
    },
    preloadImages() {
      // 预加载所有书籍图片
      const allBooks = [...this.featuredBooks, ...this.upcomingBooks]
      allBooks.forEach(book => {
        if (book.cover) {
          const img = new Image()
          img.src = book.cover
          img.onload = () => {
            book.imageLoaded = true
          }
          img.onerror = () => {
            book.imageError = true
            console.warn(`图片加载失败: ${book.cover}`)
          }
        }
      })
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        /* this.$message({
          message: `正在搜索: ${this.searchKeyword}`,
          type: 'info'
        }) */

        let _self = this
        // _self.$router.push({path:'/searchpage',query: {type:'1'}})
        _self.$router.push({
          path: '/searchpage',
          query: { type: '1' }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      } else {
        this.$message({
          message: '请输入搜索关键词',
          type: 'warning'
        })
      }
    },
    handleCategoryClick(category) {
      let _self = this;

      // 20260323，增加二级分类标签的参数传递
      let mclasslabel = "二级分类";
      if(category.remark!='' && category.remark!=null && category.remark!='null' && category.remark!=undefined && typeof category.remark !== 'object'){
        mclasslabel = category.remark;
      }

      _self.$router.push({
        path: '/classpage',
        // query: { type: category.id, classname:category.typename }    //20260323，增加二级分类标签的参数传递
        query: { type: category.id, classname:category.typename, label:mclasslabel }
      }).then(() => {
        window.scrollTo(0, 0)
      })
    },

    handleBookClick(book) {
      // 有分册的书籍此处进入内容简介页面
      if(book.booknums > 0){    // 有分册的书籍的分册数量大于0
        this.$router.push({
          path: '/singlebook',
          query: { type: book.id, bookname:book.title }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
      else{        //单行本书籍
        if(book.id < 1000000000){
          // 20260209,单行本书籍也要进入内容简介页面。单行本书籍系列建立或编辑时候，自动增加一个分册书籍（前端不可见），从而统一了多分册和单行本的后台管理和前端页面展示
          /*
          this.$router.push({
            path: '/vipread',
            query: { type: book.id, twotype: 0, bookname:book.title }
          }).then(() => {
            window.scrollTo(0, 0)
          })
          */
          this.$router.push({
            path: '/singlebook',
            query: { type: book.id, bookname:book.title }
          }).then(() => {
            window.scrollTo(0, 0)
          })
        }
        else{
          // 20260209,单行本即将出版书籍也要进入内容简介页面
          /*
          this.$message({
            message: `本书籍即将出版，敬请期待！`,
            type: 'success'
          })
          */
          this.$router.push({
            path: '/singlebook',
            query: { type: book.id, bookname:book.title }
          }).then(() => {
            window.scrollTo(0, 0)
          })
        }
      }
    },
    handleModalTagClick(tag) {
      this.$message({
        message: `正在按"${tag}"分类进行搜索`,
        type: 'info'
      })
      // console.log(`从弹出层选择分类搜索: ${tag}`)
      this.showTagsModal = false
      this.searchKeyword = tag
    },
    toggleMobileCategories() {
      this.showMobileCategories = !this.showMobileCategories
    },

    handleImageError(e) {
      console.error('Logo图片加载失败')
      e.target.style.display = 'none'
      // 可以设置一个备用logo
    },
    handleBookImageError(book) {
      console.warn(`书籍图片加载失败: ${book.title}`)
      book.imageError = true
      // 设置默认图片
      const imgElement = event.target
      imgElement.style.display = 'none'
    },
    handleBookImageLoad(book) {
      book.imageLoaded = true
      book.imageError = false
    },
    //特别推荐和即将出版
    handleMoreClick(type) {
      let _self = this
      if(type ==1){
        // _self.$router.push({path:'/recommandwill',query: {type:'1',classname:'特别推荐'}})
        // _self.$router.push({path:'/detail',query: {type:'1',classname:'测试数据接口'}})
        
        _self.$router.push({
          path: '/recommandwill',
          query: { type: '1',classname:'特别推荐' }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
      else{
        // _self.$router.push({path:'/recommandwill',query: {type:'2',classname:'即将出版'}})
        _self.$router.push({
          path: '/recommandwill',
          query: { type: '2',classname:'即将出版' }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
    },

    //获得button的宽度
    getButtonWidth() {
      if (this.$refs.mobileCategoriesBtn) {
        return this.$refs.mobileCategoriesBtn.$el.offsetWidth;
      }
      return 0;
    }
    
  }
}
</script>

<style scoped>
/* 引入外部字体和图标库 20260105*/
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

/* 导入原有的所有CSS样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Serif SC', serif;
  line-height: 1.6;
  color: #5c3a21;
  background-color: #f5f0e6;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
  min-height: 100vh;
  overflow-x: hidden;
}

.container {
  width: 100%;
  /* max-width: 1200px; 20260107，增加界面的宽度*/
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 15px;
}

.classic-border {
  border: 1px solid #c9b18b;
  border-radius: 3px;
  box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
}

.classic-bg {
  background-color: #fffaf0;
  border: 1px solid #d4c4a8;
}

/* 第一区域：顶部公司信息 */
.header-section {
  background-color: #8b4513;
  color: #f5deb3;
  /* padding: 15px 0; 20260105*/
  padding: 19px 0;
  border-bottom: 3px solid #d2691e;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
  height: 60px;
  background-color: #f5deb3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border: 2px solid #d2691e;
  overflow: hidden;
}

.logo i {
  font-size: 2rem;
  color: #8b4513;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.site-name h1 {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #f5deb3;
  letter-spacing: 2px;
  text-shadow: 1px 1px 2px #5c3a21;
}

/* 20260105 add */
.site-name h1 span{
  font-size: 1.6rem;
}
.english-part {
  display: inline-flex;
  align-items: flex-end; /* 确保MoKu和∞底部对齐 */
}
.moku {
  font-family: 'Noto Serif SC', serif;
  font-weight: 700;
}
.infinity {
  font-size: 1.2em; /* 稍微调整∞的大小 */
  margin-left: 2px; /* 添加一点间距 */
  line-height: 1; /* 防止行高影响对齐 */
}

.site-name p {
  font-size: 0.9rem;
  color: #e6d3b3;
  margin-top: 3px;
  /* 20260105 */
  font-family: 'Noto Serif SC', serif;
}

.contact-info {
  text-align: right;
}

/* 20260105 modify*/
/* .contact-info p {
  margin-bottom: 5px;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 5px;
} */
.contact-info p {
  margin-bottom: 5px;
  font-size: 0.95rem;
  text-align: right; /* 确保每个段落都右对齐 */
  font-family: 'Noto Serif SC', serif;
}

/* 第二区域：全站搜索区 */
.search-section {
  padding: 25px 0;
  background-color: #D7B974;
  border-bottom: 2px dashed #8b4513;
}

.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search-box {
  display: flex;
  width: 100%;
  max-width: 800px;
  margin-bottom: 0;
}

.search-icon {
  background-color: #8b4513;
  color: #f5deb3;
  padding: 15px 20px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  font-size: 1.2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input >>> .el-input__inner {
  /* padding: 15px; 20260105*/
  padding: 18px;
  border: 1px solid #c9b18b;
  border-left: none;
  border-right: none;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  background-color: #fffaf0;
  color: #5c3a21;
  min-width: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.search-input >>> .el-input__inner::placeholder {
  color: #8b4513;
}

.search-input >>> .el-input__wrapper {
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: #fffaf0;
  box-shadow: none;
}

.search-button {
  background-color: #a0522d;
  color: #f5deb3;
  border: none;
  padding: 0 25px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  transition: background-color 0.3s;
  flex-shrink: 0;
  height: auto;
}

.search-button:hover {
  background-color: #8b4513;
}

/* 第三区域：书籍分类与推荐 */
.main-section {
  padding: 30px 0 40px;
  background-color: #D7B974;
  border-top: 2px dashed #8b4513;
}

.main-container {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 30px;
}

/* 左侧：书籍分类 */
.categories-box {
  background-color: #fffaf0;
  padding: 25px 20px;
  border-radius: 5px;
  border: 1px solid #c9b18b;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
  position: relative;
}

.categories-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.5rem;
  color: #8b4513;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #d4c4a8;
  text-align: center;
  letter-spacing: 1px;
}

.categories-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.category-item {
  padding: 12px 15px;
  background-color: #f9f5eb;
  border-left: 4px solid #a0522d;
  border-radius: 3px;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
  /* 20260105 */
  font-family: 'Noto Serif SC', serif;
  color:#5c3a21;
}

.category-item:hover {
  background-color: #f0e6d2;
  transform: translateX(5px);
  border-left-color: #8b4513;
}

/* 期刊报纸子菜单样式 */
.category-item.journal-item {
  position: relative;
  z-index: 1;
}

.category-item.journal-item:hover .submenu,
.category-item.journal-item .submenu:hover {
  display: block;
  z-index: 99999;
}

.submenu {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  width: 180px;
  background-color: #fffaf0;
  border: 1px solid #c9b18b;
  border-radius: 5px;
  box-shadow: 0 10px 30px rgba(92, 58, 33, 0.4);
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 0;
  z-index: 99999 !important;
}

.category-item.journal-item:hover .submenu {
  display: block;
}

.submenu-item {
  padding: 10px 15px;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.submenu-item:hover {
  background-color: #f0e6d2;
  border-left-color: #a0522d;
  padding-left: 20px;
}

/* 右侧：推荐区域 */
.recommendations-box {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.recommendation-section {
  background-color: #fffaf0;
  padding: 25px;
  border-radius: 5px;
  border: 1px solid #c9b18b;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d4c4a8;
}

.section-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.5rem;
  color: #8b4513;
  letter-spacing: 1px;
}

.more-link {
  color: #a0522d;
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.3s;
  display: flex;
  align-items: center;
  gap: 3px;
  /* 20260105 */
  font-family: 'Noto Serif SC', serif;
}

.more-link:hover {
  color: #8b4513;
  text-decoration: underline;
}

/* 书籍网格 */
.books-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.book-item {
  text-align: center;
  transition: transform 0.3s;
}

.book-item:hover {
  transform: translateY(-5px);
}

.book-cover {
  width: 100%;
  height: 0;
  padding-bottom: 140%;
  position: relative;
  background-color: #e6d3b3;
  margin-bottom: 12px;
  border-radius: 3px;
  overflow: hidden;
  border: 1px solid #c9b18b;
  box-shadow: 0 3px 6px rgba(92, 58, 33, 0.1);
}

.book-cover img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
}

/* 图片占位符 */
.image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #8b4513 0%, #a0522d 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #f5deb3;
  padding: 10px;
}

.image-placeholder i {
  font-size: 2rem;
  margin-bottom: 10px;
  opacity: 0.8;
}

.image-placeholder span {
  font-size: 0.9rem;
  text-align: center;
  line-height: 1.2;
}

.book-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #5c3a21;
  margin-bottom: 5px;
  line-height: 1.4;
  width: 100%;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  padding: 0 2px;
  /* 20260105 */
  font-family: 'Noto Serif SC', serif;
}

/* 第四区域：页脚 */
.footer-section {
  background-color: #5c3a21;
  color: #e6d3b3;
  padding: 25px 0;
  border-top: 3px solid #8b4513;
}

.footer-info {
  text-align: center;
  line-height: 1.8;
}

.footer-info p {
  margin-bottom: 8px;
  font-size: 0.95rem;
  /* 20260105 */
  font-family: 'Noto Serif SC', serif;
}

/* 移动端书籍分类折叠按钮 */
.mobile-categories-toggle {
  display: none;
  width: 100%;
  height: 52px;   /**20260108 add */
  background-color: #a0522d;
  color: #f5deb3;
  border: 1px solid #8b4513;
  border-radius: 5px;
  padding: 12px 15px;
  font-family: 'Noto Serif SC', serif;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s;
}

.mobile-categories-toggle:hover {
  background-color: #8b4513;
}

.toggle-icon {
  font-size: 1.2rem;
  transition: transform 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

/* 对话框自定义样式 */
.custom-modal >>> .el-dialog {
  background-color: #fffaf0;
  border-radius: 8px;
  border: 2px solid #c9b18b;
}

.custom-modal >>> .el-dialog__header {
  border-bottom: 2px solid #d4c4a8;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.custom-modal >>> .el-dialog__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  letter-spacing: 1px;
}

.custom-modal >>> .el-dialog__body {
  padding: 0 30px 20px;
}

.custom-modal >>> .el-dialog__footer {
  border-top: 1px solid #d4c4a8;
  padding-top: 20px;
}

.modal-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
}

.modal-tag {
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 1rem;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.modal-tag:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  transform: translateY(-2px);
}

.modal-description {
  font-size: 1rem;
  line-height: 1.7;
  color: #5c3a21;
  background-color: #f9f5eb;
  padding: 20px;
  border-radius: 5px;
  border: 1px dashed #c9b18b;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .main-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .books-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .custom-modal >>> .el-dialog {
    width: 95%;
  }
  
  .modal-tag {
    min-width: 150px;
  }
  
  /* 移动设备上调整子菜单位置 */
  .submenu {
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 99999 !important;
  }
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-info {
    text-align: left;
    margin-top: 15px;
  }
  
  .site-name h1 {
    font-size: 1.5rem;
  }
  
  /* 搜索框不换行 */
  .search-box {
    flex-direction: row;
    overflow: hidden;
  }
  
  .search-icon, .search-input, .search-button {
    border-radius: 0;
    border: 1px solid #c9b18b;
    margin: 0;
    width: auto;
    flex-shrink: 0;
  }
  
  .search-icon {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    padding: 15px;
    width: 50px;
  }
  
  .search-input >>> .el-input__inner {
    flex: 1;
    min-width: 0;
    border-left: none;
    border-right: none;
    padding: 15px 10px;
  }
  
  .search-button {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 15px 20px;
    white-space: nowrap;
  }
  
  /* 手机上每行显示2本书 */
  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .custom-modal >>> .el-dialog {
    width: 98%;
  }
  
  .modal-tags {
    gap: 10px;
  }
  
  .modal-tag {
    min-width: 120px;
    padding: 10px 15px;
    font-size: 0.9rem;
  }

  /* 20260108 add，手机上隐藏书籍分类的标题 */
  .categories-title{
    display: none;
  }
  
  .categories-title, .section-title {
    font-size: 1.3rem;
  }
  
  /* 移动端书籍分类样式 */
  .mobile-categories-toggle {
    display: flex;
    order: -1;
  }
  
  .main-container {
    display: flex;
    flex-direction: column;
  }
  
  .categories-box {
    display: none;
    order: -1;
    margin-top: 0;
    margin-bottom: 20px;
  }
  
  .categories-box.show {
    display: block !important;
  }
  
  .categories-title {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }
  
  .categories-list {
    gap: 10px;
  }
  
  .category-item {
    padding: 10px 12px;
    font-size: 0.9rem;
  }
  
  .submenu {
    z-index: 99999 !important;
    box-shadow: 0 4px 15px rgba(92, 58, 33, 0.25);
  }
  
  /* 移动端书名显示调整 */
  .book-title {
    font-size: 0.9rem;
    line-height: 1.4;
  }
}

@media (max-width: 576px) {
  .site-name h1 {
    font-size: 1.3rem;
  }
  
  .logo {
    width: 50px;
    height: 50px;
  }
  
  .logo i {
    font-size: 1.5rem;
  }
  
  .contact-info p {
    font-size: 0.85rem;
  }
  
  /* 手机上保持每行2本书 */
  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .categories-title, .section-title {
    font-size: 1.2rem;
  }
  
  .recommendation-section {
    padding: 20px;
  }
  
  .footer-info p {
    font-size: 0.85rem;
  }
  
  .modal-tag {
    min-width: 100%;
  }
  
  /* 手机上进一步优化搜索框 */
  .search-icon {
    width: 45px;
    padding: 12px;
  }
  
  .search-button {
    padding: 12px 15px;
    font-size: 0.9rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  /* 移动端分类按钮调整 */
  .mobile-categories-toggle {
    padding: 10px 12px;
    font-size: 0.95rem;
  }
  
  .toggle-icon {
    font-size: 1.1rem;
  }
  
  /* 移动端书名显示调整 */
  .book-title {
    font-size: 0.85rem;
  }
}

@media (max-width: 400px) {
  /* 超小屏幕仍然保持每行2本书 */
  .books-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .book-title {
    font-size: 0.8rem;
  }
  
  /* 超小屏幕搜索框优化 */
  .search-icon {
    width: 40px;
    padding: 10px;
    font-size: 1rem;
  }
  
  .search-button {
    padding: 10px 12px;
    font-size: 0.85rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  /* 超小屏幕分类按钮 */
  .mobile-categories-toggle {
    padding: 8px 10px;
    font-size: 0.9rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue